import { useState } from "react";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { PageFor } from "../../../../../utils/Enum.types";

import PreviousMeetingDetails from "./PreviousMeetingDetails";
import PresentMeetingDetails from "./PresentMeetingDetails";

export const Header = [
  "Sl",
  "Observations",
  "Vendor Compliance",
  "Compliance By Authority /PMU",
];

interface Props {
  previous_details: boolean;
}

const MeetingDetails = ({ previous_details }: Props) => {
  const [presentDetails, setPresentDetails] = useState(false);

  const { momID } = useUrlParams();
  return (
    <div className="meeting-details">
      {previous_details ? (
        <>
          <div className="meeting-details--left">
            <PresentMeetingDetails pageType={PageFor.GENERAL} />
          </div>
        </>
      ) : null}

      <div
        className="meeting-details--right"
        style={{ width: previous_details ? "50%" : "100%" }}
      >
        <PreviousMeetingDetails
          pageType={PageFor.VIEW}
          momID={momID!}
          latest={true}
          setPresentDetails={setPresentDetails}
        />
      </div>
    </div>
  );
};

export default MeetingDetails;
